export const coachTrainingSkillContract = {
  id: 'coach_training',
  version: '1.0.0',
  name: 'Mi Coach',
  domain: 'fps_mobile',
  supportedGames: ['pubg_mobile', 'free_fire', 'codm', 'other'],
  gameAliases: {
    codm: ['cod', 'cod mobile', 'call of duty mobile', 'call of duty: mobile']
  },
  description: 'Transforma objetivo, dor ou contexto recente do jogador em treino, trilha, progresso ou proxima acao da Coach.',
  intentExamples: [
    'me passa um treino',
    'quero treinar recoil',
    'minha mira sobe, o que treino hoje?',
    'continua minha trilha',
    'abre meu primeiro treino',
    'marca esse treino como concluido',
    'salva esse treino',
    'mostra meu progresso'
  ],
  intents: [
    'recommend_training',
    'continue_track',
    'open_training',
    'complete_training',
    'save_training',
    'show_progress'
  ],
  requiredSlots: ['gameOrProfile', 'trainingIntent'],
  requiredSlotsByIntent: {
    recommend_training: ['gameOrProfile', 'trainingIntent', 'painOrObjective'],
    continue_track: ['gameOrProfile', 'trainingIntent'],
    open_training: ['trainingIntent', 'trainingId'],
    complete_training: ['trainingIntent', 'trainingId'],
    save_training: ['trainingIntent', 'trainingId'],
    show_progress: ['gameOrProfile', 'trainingIntent']
  },
  optionalSlots: [
    'pain',
    'objective',
    'trainingId',
    'trackId',
    'recentDiagnosis',
    'progressAction',
    'language'
  ],
  slotSchemas: {
    gameOrProfile: {
      type: 'string',
      description: 'Jogo informado ou perfil Coach ja salvo.'
    },
    trainingIntent: {
      type: 'enum',
      values: [
        'recommend_training',
        'continue_track',
        'open_training',
        'complete_training',
        'save_training',
        'show_progress'
      ]
    },
    painOrObjective: { type: 'string' },
    pain: { type: 'string' },
    objective: { type: 'string' },
    trainingId: {
      type: 'string',
      source: 'coach_training_library'
    },
    trackId: {
      type: 'string',
      source: 'coach_track_library'
    },
    recentDiagnosis: { type: 'object' },
    progressAction: {
      type: 'enum',
      values: ['start', 'complete', 'save', 'unsave']
    },
    language: { type: 'string' }
  },
  askForMissingSlots: {
    gameOrProfile: 'Qual jogo voce quer treinar agora?',
    trainingIntent: 'Voce quer um treino novo, continuar a trilha, abrir treino, salvar ou ver progresso?',
    painOrObjective: 'Qual ponto voce quer corrigir hoje?',
    trainingId: 'Qual treino voce quer abrir ou atualizar?'
  },
  execution: {
    handler: 'CoachTrainingSkillAdapter',
    requiresBackend: true,
    costClass: 'medium',
    requiresCredits: false,
    requiresPlan: 'free_first_training_or_pro'
  },
  output: {
    mode: 'conversation',
    schema: 'training_result'
  },
  guardrails: {
    doNotCreateFakeTraining: true,
    useRealCoachLibrary: true,
    doNotEraseProgress: true,
    doNotBypassBackendOnboardingRules: true,
    freeUserCannotRetakeOnboardingIfBackendBlocks: true,
    firstFreeTrainingMustRemainStable: true,
    premiumTrainingContentMustNotLeakToFree: true
  },
  capabilityMapping: {
    primaryCapabilityId: 'training_single_drill',
    relatedCapabilityIds: ['training_favorites']
  }
};

export default coachTrainingSkillContract;
